import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

export default function FarmersCta() {
  return (
    <section className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="bg-primary-900 rounded-lg p-8 md:p-14 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
                Are You a Farmer?
              </span>
              <h2 className="font-heading text-3xl md:text-4xl leading-tight text-background-50 font-semibold mt-4">
                Turn Your Farm Into an Experience
              </h2>
              <p className="mt-5 text-base text-background-200 leading-relaxed">
                Your farm has more to offer than just crops. Showcase your farm and share your
                story with families, students, corporates and travellers — while earning
                supplementary income.
              </p>
            </div>
            <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-3">
              <Link
                to="/farm-partner"
                className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Become a Farm Partner
                <i className="ri-plant-line"></i>
              </Link>
              <Link
                to="/#experiences"
                className="inline-flex items-center justify-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm font-semibold px-7 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                Explore Experiences
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}